import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

const initialState = {
  notifier: {
    isOpen: false,
    status: "success",
    title: "Success!",
    description: ""
  },
  notesModal: {
    openModal: false,
    adminId: "",
    participantId: "",
    userAssessmentCycleId: undefined
  },
  loading: false,
  error: false
};

ReactDOM.render(<App initialState={initialState} />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
